const OBSERVATORY = {
  RAIN: {
    code: 1,
    name: "雨量"
  },
  STAGE: {
    code: 4,
    name: "水位"
  },
  DAM: {
    code: 7,
    name: "ダム"
  },
  CAMERA: {
    code: 30,
    name: "カメラ"
  },
  LIVECAMERA: {
    code: 31,
    name: "ｶﾒﾗ(動画)"
  },
  OVERFLOW_WATERWAY: {
    code: 42,
    name: "調整池"
  },
  SUIJIN: {
    code: 43,
    name: "浸水ｾﾝｻ"
  },
  MANHOLE: {
    code: 45,
    name: "マンホール"
  },
  MANHOLE_WATERWAY: {
    code: 46,
    name: "水路"
  },
  PUMP: {
    code: 60,
    name: "ポンプ"
  }
};

const STAGES = {
  OUTBREAK: {
    label: "氾濫発生水位",
    color: "#000000"
  },
  DANGEROUS: {
    label: "氾濫危険水位",
    color: "#AD02AD"
  },
  EVACUATION: {
    label: "避難判断水位",
    color: "#FF2800"
  },
  WARNING: {
    label: "氾濫注意水位",
    color: "#FFA500"
  },
  STANDBY: {
    label: "水防団待機水位",
    color: "#008000"
  },
  START: {
    label: "観測開始水位",
    color: "#22b022"
  },
  NORMAL: {
    label: "平常",
    color: "#ffffff"
  },
  DEFICIT: {
    label: "休止・欠測等",
    color: "#aaaaaa"
  }
};

const MapPane = {
  ObservatoryMarkersLayer: {
    name: "observatory-markers-layer",
    zIndex: 600
  },
  ObservatorySendorMarkersLayer: {
    name: "observatory-sensor-markers-layer",
    zIndex: 600
  },
  BranchOfficeMarker: {
    name: "branch-office-marker",
    zIndex: 610
  }
};

export { OBSERVATORY, STAGES, MapPane };
